<template>
  <div id="app">
    <header>
      <div id="nav">
        <b-navbar toggleable="lg" type="light" variant="mdh">
          <b-navbar-brand>
            <img src="./assets/logo-reverse.png" style="height:38px;" alt="Minnesota Department of Health Logo"/>
          </b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav>
              <b-nav-item href="/">Home</b-nav-item>
              <b-nav-item href="/home" v-if="authenticated" @click="clearLocal()">Dashboard</b-nav-item>
              <b-nav-item href="/orders" v-if="authenticated">My Orders</b-nav-item>
              <b-nav-item href="/product-select" @click="clearLocal()">Start New Order</b-nav-item>
              <b-nav-item href="/product-select" v-if="orderExists">Add Another Product</b-nav-item>

              <b-nav-item-dropdown id="menu_admin" text="Admin"
                                   v-if="authenticated && (hasRole('mdh-admin') || hasRole('mdh-staff'))">
              </b-nav-item-dropdown>

              <b-nav-item href="/terms-of-service">Terms of Service</b-nav-item>
              <b-nav-item href="/faq">FAQ</b-nav-item>

              <b-nav-item @click="logout" v-if="authenticated">Log out</b-nav-item>
              <b-nav-item href="/home" v-if="!authenticated">Log in</b-nav-item>
              <b-nav-item href="/register" v-if="!authenticated">Create Account</b-nav-item>
            </b-navbar-nav>
            <b-navbar-nav class="ml-auto">
              <b-nav-item href="/cart" :key="cartItems">
                <b-icon icon="cart2" class="cart"/>
                <span class='badge' id='lblCartCount'>{{cartItems}}</span>
              </b-nav-item>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </header>

    <main id="main-content">
      <b-container fluid>
              <router-view v-on:cart-update="updateCartItems()" v-on:update-order="hasOrder()"/>
      </b-container>
    </main>

    <footer>
      <div class="mt-5 pl-2 pr-2">
        <hr/>
        <div class="fluid-container footer justify-content-center">
          <p class="text-center small">
            <span>
              Questions? Contact the <a href="https://www.health.state.mn.us/people/vitalrecords/about.html" class="mdh-green-link">Office of Vital Records</a> at 651-201-5970 or <a href="mailto:health.vitalrecords@state.mn.us" class="mdh-green-link">health.vitalrecords@state.mn.us</a>.
            </span><br/>
            <span>
                 v{{appVersion}}
            </span>
            <span>
                - Last Updated: {{lastModified}}:
            </span>

          </p>
        </div>
      </div>
    </footer>

  </div>
</template>

<script>
  import LocalStorageService from '@/common/LocalStorageService';
  import {version} from '../package.json';

  const localStorageService = LocalStorageService.getService();

  export default {
    metaInfo: {
      title: 'Welcome',
      htmlAttrs: {
        lang: 'en',
        amp: true
      }
    },
    data: () => ({
      cartItems: localStorageService.getCartItems(),
      orderExists: false,
    }),
    computed: {
      localStorageService() {
        return localStorageService
      },
      authenticated: function() {
        if (this.$keycloak) {
          return this.$keycloak.authenticated;
        } else {
          return false;
        }
      },
      appVersion: function() {
          return version;
      },
      lastModified: function(){
        var buildTimestamp = new Date(document.documentElement.dataset.buildTimestampUtc);
        var year = buildTimestamp.getFullYear();
        var month = (buildTimestamp.getMonth()+1).toString();
        month = month.length > 1 ? month: '0'+month;
        var day = buildTimestamp.getDate().toString();
        day = day.length > 1 ? day : '0'+day;
        return month+'/'+day+'/'+year;
      },
    },

    methods: {
      logout() {
        localStorageService.clearAuthTokens()
        this.$store.dispatch('resetState')
        this.$keycloak.clearToken()
        this.$keycloak.logoutFn()
        this.clearLocal()
      },
      clearLocal() {
        localStorageService.clearCartItems()
        localStorageService.clearOrderNumber()
        localStorageService.clearOrderType()
        localStorageService.clearIsDraft()
        this.hasOrder()
        this.updateCartItems()
      },
      hasRole(roles) {
        if (this.$keycloak) {
          return this.$keycloak.hasResourceRole(roles)
        } else {
          return false;
        }
      },
      updateCartItems() {
        this.cartItems = localStorageService.getCartItems()
      },
      hasOrder() {
        this.orderExists = localStorageService.getOrderNumber() && localStorageService.getOrderNumber() != null
      },
    },
    created() {
      this.hasOrder()
    },
  }
</script>

<style lang="scss">

  @import "assets/_custom.scss";
  @import "vue-select/src/scss/vue-select.scss";
  @import "~bootstrap/scss/bootstrap.scss";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');
#app {
  font-family: 'Roboto', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #1F2E37;
}

.container-fluid {
  max-width: 1440px;
}

h1, .h1 {
  font-size: 30px;
  font-weight: 600;
}

h2, .h2 {
  font-size: 24px;
  font-weight: 600;
}

h3, .h3 {
  font-size: 18px;
  font-weight: 600;
}

button {
  margin-right: 18px;
}

ul {
  list-style-type: none;
  padding: 0;
}

.bg-mdh {
  background-color: rgb(0, 56, 101);
}

#nav {
  padding-bottom: 30px;
}

#nav a {
  font-weight: normal;
  color: white;
}

.dropdown-nav .nav-link {
  color: #1F2E37 !important;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

#nav  a.dropdown-item {
  color: black !important;
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}
.sr-only-focusable:active,
.sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  clip: auto;
}

.colWidth40 {
  width: 40%;
}

.is-invalid .d-block {
    color: #EB0000;
}

.label-required::after {
  color: #0a8927;
  font-size: .7em;
  text-transform: uppercase;
  margin-left: 19px;
  content:" required";

}

@media (max-width: 380px) {
  .wizard-btn {
    margin-right: 0 !important;
  }
}

@media (max-width: 576px) {
  .wizard-card-footer {
    padding: 0 !important;
  }
  .p-xs-0 {
    padding: 0 !important;
  }
}


.wizard-card-footer div span {
  outline: none;
}

.wizard-card-footer div span:focus button {
  -webkit-box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
  box-shadow: 0 0 0 0.2rem rgba(155, 89, 182, 0.25);
}

.wizard-nav li:has(.disabled) {
  user-focus: none;
 }

 .card {
   margin-bottom: 2em;
 }

  .navbar-light .navbar-toggler-icon {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 1%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  }

  .navbar-light .navbar-toggler {
    border-color: white;
  }

  .navbar-light .navbar-toggler:focus, .navbar-light .navbar-toggler:hover, .navbar-light .navbar-toggler:focus-visible {
    outline: 2px solid #78BE21;
  }

  .sr-caption caption {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
  .sr-caption caption:active,
  .sr-caption caption:focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
  }
  .btn-outline-primary {
    color: #003865;
    border-color: #003865;
  }

  .btn-outline-primary:active, .btn-outline-primary:hover, .btn-primary:not(:disabled):not(.disabled):active,
  .btn-outline-primary:not(:disabled):not(.disabled):active, .show > .btn-outline-primary.dropdown-toggle {
    color: #fff;
    background-color: #003865;
    border-color: #003865;
  }

  .wizard-btn, .wizard-btn:hover, .wizard-btn:focus, .btn-primary, .btn-primary:hover, .btn-primary:focus {
    background-color: #003865;
    border-color: #003865;
    color: #ffffff;
    outline-color: #A8D8FF;
  }

  .btn-outline-primary:focus {
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.5);
  }

  .btn-outline-primary:disabled {
    color: #003865;
  }

  .green-required::after {
    color: #78BE21;
    font-size: .7em;
    text-transform: uppercase;
    margin-left: 19px;
    content: " required";
    font-weight: 750;
  }

  .btn-success {
    background-color: #208836;
    border-color: #208836;
  }

  .btn-success:focus, .btn-success:hover, .btn-success:focus-visible {
    outline-color: #AADFB5;
  }

  .btn-secondary:focus, .btn-secondary:hover, .btn-secondary:focus-visible {
    outline-color: #CBD0D2;
  }

  .mdh-green-link, .mdh-green-link:hover, .mdh-green-link:focus {
    color: #3D792A;
    text-decoration: underline;
  }

  .badge {
    padding-left: 9px;
    padding-right: 9px;
    -webkit-border-radius: 9px;
    -moz-border-radius: 9px;
    border-radius: 9px;
  }

  #lblCartCount {
    font-size: 12px;
    background: #3D792A;
    color: #fff;
    padding: 0 5px;
    vertical-align: top;
    margin-left: -10px;
  }

  @media print {
    .no-print {
      visibility: hidden;
      display: none;
    }
  }

</style>
